import { I18N } from "./I18N.js"

export class UserInfo {
	_login
	_counter

	constructor(target, login, counter) {
		this._target = document.getElementById(target)
		this._login = login
		this._counter = counter
	}

	
	setVisible = visible => {
		if (visible) {
			const user = this._login.getUser()
			console.log('User: ', user)
			this._target.innerHTML = `
				<div class="card">
					<h1 i18n>User Info</h1>
					<table class="priceTable">
						<tbody>
							<tr>
								<td class="label"><label><span i18n>Name</span>:</label></td>
								<td>${user.firstName} ${user.lastName}</td>
							</tr>
							<tr>
								<td class="label"><label><span i18n>eMail</span>:</label></td>
								<td>${user.email}</td>
							</tr>
							<tr>
								<td class="label"><label><span i18n>Roles</span>:</label></td>
								<td>
									<ul>${user.roles.filter(r => !['default-roles-fairweben', 'offline_access', 'uma_authorization'].includes(r)).map(r => I18N.translate(r)).map(r => `<li>${r}</li>`).join('')}</ul>
								</td>
							</tr>
							<tr>
								<td class="label"><label><span i18n>Groups</span>:</label></td>
								<td>
									<ul>${user.groups.map(r => r.substring(1).replace('/', '@')).map(r => `<li>${r}</li>`).join('')}</ul>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				${this._counter && navigator.userAgent.includes('Windows') ? `
				<div class="card" id="agentSettings">
					<h2 i18n>Windows companion app</h2>
					<label>
						<input type="checkbox" id="showAgentDownloadBannerCb" ${this._counter.isAgentDownloadBannerVisible() ? 'checked' : ''}>
						<span i18n>Show download hint in the counter</span>
					</label>
					<small i18n>Also shown while the companion app is running, e.g. to download an update or the portable version.</small>
				</div>` : ''}
			`
			I18N.translateElement(this._target)
			this._target.querySelector('#showAgentDownloadBannerCb')?.addEventListener('change', ev => this._counter.setAgentDownloadBannerVisible(ev.currentTarget.checked))
		}
		else {
			this._target.innerHTML = ''
		}
	}



}